import { Star } from "lucide-react";

import { cn } from "@/shared/lib/utils";

export interface MediaFavoriteToggleProps {
  isFavorite?: boolean;
  onToggle: () => void;
  className?: string;
}

/**
 * 媒体列表卡的收藏星标(海报 / 视频 / 分身**三线共用**)。
 *
 * 2026-07-15 三线列表对齐:此前只有海报卡有;视频/分身的后端 DTO 那时连 isFavorite 都不透出
 * (列在共用的 xb_media_task 上早就存在,只是没接线)。
 *
 * 单独成组件而不并进 <MediaCardActionRow>:三线的星都长在**标题行右侧**(与标题同行),
 * 不在底部操作行里 —— 位置不同,合成一个组件反而要塞布局参数。
 *
 * aria-label 随状态变(「收藏」/「取消收藏」),读屏用户才知道当前是什么状态、按下去会发生什么。
 */
export function MediaFavoriteToggle({
  isFavorite = false,
  onToggle,
  className,
}: MediaFavoriteToggleProps) {
  return (
    <button
      type="button"
      onClick={(e) => {
        // 标题/封面多半可点(预览/进详情),点星星不能连带触发。
        e.stopPropagation();
        onToggle();
      }}
      className={cn("shrink-0 rounded-full p-0.5 hover:bg-accent", className)}
      title={isFavorite ? "取消收藏" : "收藏"}
      aria-label={isFavorite ? "取消收藏" : "收藏"}
      aria-pressed={isFavorite}
    >
      <Star
        className={cn(
          "h-4 w-4",
          isFavorite ? "fill-warning text-warning" : "text-muted-foreground"
        )}
      />
    </button>
  );
}
